import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TypeEnum } from '../../../../models/template/type.enum';
import { MetaStatusEnum } from '../../../../models/whatsapp-template/meta-status-enum.enum';
import { TemplateEditorComponent } from '../../base-template-editor/template-editor.component';

@Component({
    selector: 'app-whatsapp-template',
    imports: [TemplateEditorComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `
    <app-template-editor
      [templateType]="templateType"
      templateBasePath="/whatsapp-template/"
      channelLabel="Whatsapp"
      namePlaceholder="Enter whatsapp name"
      emptyMessage="No whatsapp found!"
      heartbeatType="whatsapp"
      [showMetaSection]="true"
      [showTranslateButton]="false"
      [metaStatus]="metaStatus"
      [subscribeToMedia]="true"
      [sendsToMeta]="true"
      [loadsMetaStatus]="true"
      [defaultBlocks]="defaultBlocks" />
  `
})
export class WhatsappTemplateComponent {
  protected readonly templateType = TypeEnum.WHATSAPP;
  protected readonly metaStatus = MetaStatusEnum.NEVER_SENT;

  protected readonly defaultBlocks: { name: string; variables: Record<string, string> }[] = [
    {
      name: 'whatsapp',
      variables: {
        WhatsappImage: '',
        WhatsappText: '',
        WhatsappCtaText: '',
        WhatsappCtaLink: '',
      },
    },
  ];
}
